import { ContentContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext, useState } from 'react';

import CasesTrend from './CasesTrend';
import Options from './Options';
import SmartText from '@reuters-graphics/react-smart-text';
import StripPlot from './StripPlot';
import { component } from './styles.module.scss';

const LockdownTimeline = (props) => {
  const { lockdownData, caseCounts } = props;
  const locale = useContext(LocaleContext);
  const content = useContext(ContentContext).template.lockdown;

  const [category, setCategory] = useState('c1');

  const seriesLimits = [
    lockdownData.series[0].split('T')[0],
    lockdownData.series.slice(-1)[0].split('T')[0],
  ];

  return (
    <div className={component}>
      <div className='section-spacer-internal before' />
      <div>
        <h4>{content.title}</h4>
        <SmartText
          source={content.intro}
          // context={}
          multiline
        />
        <div className='section-spacer-internal' />
        <Options
          activeCategory={category}
          setCategory={setCategory}
          content={content.chart}
        />
        <div className='section-spacer-internal' />
        <CasesTrend
          cases={caseCounts}
          dateRange={seriesLimits}
          locale={locale}
          content={content.trend}
        />
        <StripPlot
          lockdownData={lockdownData}
          locale={locale}
          activeCategory={category}
          content={content.chart}
        />
      </div>
      <div className='section-spacer-internal' />
    </div>
  );
};

export default LockdownTimeline;
